var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortugues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3802_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.49996C0 11.9397 2.171 14.872 5.21734 16.0023L5.91303 8.49993L5.21734 0.997559C2.171 2.12793 0 5.06025 0 8.49996Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 8.5C15.9999 4.08175 12.4182 0.5 7.99994 0.5C7.02138 0.5 6.08397 0.676031 5.21729 0.997594V16.0024C6.08397 16.324 7.02138 16.5 7.99994 16.5C12.4182 16.5 15.9999 12.9183 15.9999 8.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21716 11.2825C6.75395 11.2825 7.99976 10.0367 7.99976 8.49988C7.99976 6.96309 6.75395 5.71729 5.21716 5.71729C3.68038 5.71729 2.43457 6.96309 2.43457 8.49988C2.43457 10.0367 3.68038 11.2825 5.21716 11.2825Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 7.10864V8.84777C3.65234 9.71221 4.35309 10.413 5.21756 10.413C6.08203 10.413 6.78278 9.71224 6.78278 8.84777V7.10864H3.65234Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21755 9.36947C4.92986 9.36947 4.6958 9.13541 4.6958 8.84772V8.1521H5.73927V8.84776C5.73927 9.13541 5.50521 9.36947 5.21755 9.36947Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3802_909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugues);
export default __webpack_public_path__ + "static/media/portugues.7c5b7cd762e6b61bf9609ce0f6c5063d.svg";
export { ForwardRef as ReactComponent };